import { communicationsStatusPagePreviewEntrypoint } from '@jira/communications__status-page-preview/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';

export const StatusPagePreviewPageEntryPoint = createPageEntryPoint({
	main: communicationsStatusPagePreviewEntrypoint,
});
